import { TableColumnsType } from "antd";
import React from "react";
import ReusableTable from "../../../../../../global components/Table/Table";
import { InactiveKeys } from "../../../../../../libs/Utils/Types/APIManagement";
import useSWR from "swr";
import { swrFetcher } from "../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../libs/api/userSession";
import s from "./RevokedKeys.module.scss";
type ColumnType = {
  key: string;
  apiKey: string;
  owner: string;
  request: number;
  actions: string;
};
function RevokedKeys() {
  const token = UseAuthToken();
  const { data, isLoading } = useSWR<{data:InactiveKeys[]}, any, any>(
    token ? ["api/admin/api-keys/revoked", token] : null,
    swrFetcher
  );
  const columns: TableColumnsType<ColumnType> = [
    {
      title: "API key",
      dataIndex: "apiKey",
      key: "apiKey",
      render: (apiKey: string) => <span>{apiKey}</span>,
    },
    {
      title: "Owner",
      dataIndex: "owner",
      key: "owner",
      render: (owner: string) => <span>{owner}</span>,
    },
    {
      title: "Requests",
      dataIndex: "request",
      key: "request",
      render: (request: string) => <span>{request}</span>,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status: string) => (
        <span className={s.revoked}>{"Revoked"}</span>
      ),
    },
  ];
  const dataSource: ColumnType[] =
    data?.data.map((item) => ({
      apiKey: item.keyPreview,
      key: item.id,
      owner: item.firstName + " " + item.lastName,
      request: item.totalVolume || 0,
      actions: "",
    })) ?? [];
  return (
    <ReusableTable
      columns={columns}
      dataSource={dataSource}
      loading={isLoading}
    />
  );
}

export default RevokedKeys;
